import { centerStyle } from '@assets/styles/styles'
import styled from '@emotion/styled'

export const LoaderContainer = styled.div`
  height: 430px;
  ${centerStyle}
`
